import 'script-loader!jquery-toast-plugin';

//TOAST DEFINITION FUNCTION
const getBgColorByType = (type = 'info') => {
    const colorMap = {
        success: '#3C763D',
        warning: '#FF6700',
        error: '#A94442',
    };
    return colorMap[type] ?? '#31708F';
}

//TOAST GET TYPE FOR ICON
const flashyType = (type = 'i00') => {
    const toastType = (type.length > 0) ? type: 'i00';
    const switchToastType = toastType.charAt(0);
    const typeMap = {
        s: 'success',
        w: 'warning',
        e: 'error',
    }
    return typeMap[switchToastType.toLowerCase()] ?? 'info';
}

export function flashy(title, body, type = 'i', progressBar = false) {
    let bgColor = getBgColorByType(flashyType(type));
    type = flashyType(type);
    $.toast({
        heading: type,
        text: body,
        icon: type,
        loader: progressBar,
        position: 'top-right',
        bgColor:bgColor,
    });
}